export default function Eyebrow({ children, className = "" }) {
  return (
    <span
      className={`inline-block text-xs md:text-sm tracking-[0.22em] uppercase text-magenta font-semibold ${className}`}
    >
      {children}
    </span>
  );
}
